import { useEffect, useState } from "react";
import { Mail, MessageCircle, Clock } from "lucide-react";
import Layout, { PageHeader } from "../components/Layout";
import { api } from "../lib/api";

export default function Contact() {
  const [wa, setWa] = useState("");
  useEffect(() => { api.get("/settings").then(r => setWa(r.data.whatsapp_number)); }, []);
  const items = [
    { icon: MessageCircle, label: "WhatsApp (reports & queries)", value: wa, href: `https://wa.me/${wa.replace(/\D/g, "")}`, id: "contact-whatsapp" },
    { icon: Mail, label: "Email", value: "dr.porwal@porwaloncology.in", href: "mailto:dr.porwal@porwaloncology.in", id: "contact-email" },
    { icon: Clock, label: "Consultation hours (IST)", value: "10:00–13:00 & 17:00–19:00", id: "contact-hours" },
  ];
  return (
    <Layout>
      <PageHeader eyebrow="Contact" title="We're here to help" subtitle="For appointment queries or to share reports, WhatsApp is the fastest way to reach the clinic." />
      <section className="max-w-4xl mx-auto px-4 sm:px-8 py-14 grid sm:grid-cols-3 gap-6">
        {items.map(it => (
          <div key={it.id} className="bg-white border border-slate-200 rounded-2xl p-6" data-testid={it.id}>
            <it.icon className="w-6 h-6 text-teal-700" />
            <div className="mt-4 text-xs uppercase tracking-wider text-slate-500">{it.label}</div>
            {it.href ? <a href={it.href} target="_blank" rel="noreferrer" className="mt-1 block text-slate-900 font-medium hover:text-teal-700 break-words text-sm sm:text-base">{it.value}</a>
              : <div className="mt-1 text-slate-900 font-medium">{it.value}</div>}
          </div>
        ))}
      </section>
      <p className="max-w-4xl mx-auto px-4 sm:px-8 text-sm text-slate-500">In a medical emergency, please go to the nearest hospital immediately.</p>
    </Layout>
  );
}
